"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useIRRenderer;
exports.imageDataToCanvas = imageDataToCanvas;
var _react = require("react");
var _useRenderer = _interopRequireDefault(require("./useRenderer.js"));
var _useImageInfo = _interopRequireDefault(require("./useImageInfo.js"));
var _useMarkerInfo = _interopRequireDefault(require("./useMarkerInfo.js"));
var _useColorbar3 = _interopRequireDefault(require("../../Colorbar/useColorbar.js"));
var _excluded = ["isReady", "loadBuffer", "runRender", "getJSON", "getImageVL", "getImageIR", "getMarkerObject", "getPaletteData"],
  _excluded2 = ["setMarkerInfo", "modifyMarkerInfo", "getNextMarkerIndex", "deleteFromMarkerInfo"],
  _excluded3 = ["type", "id", "name"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function createImageFromBuffer(_x) {
  return _createImageFromBuffer.apply(this, arguments);
}
function _createImageFromBuffer() {
  _createImageFromBuffer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(buffer) {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt("return", new Promise(function (resolve, reject) {
            var blob = new Blob([buffer], {
              type: "image/jpeg"
            });
            var objectURL = URL.createObjectURL(blob);
            var image = new window.Image();
            image.src = objectURL;

            // Wait for the image to load
            image.onload = function () {
              // Clean up the object URL to release resources
              URL.revokeObjectURL(objectURL);

              // Resolve the promise with the loaded image
              resolve(image);
            };
            image.onerror = function (error) {
              // Clean up the object URL on error
              URL.revokeObjectURL(objectURL);

              // Reject the promise with the error
              reject(error);
            };
          }));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _createImageFromBuffer.apply(this, arguments);
}
function imageDataToCanvas(imageData) {
  // imageData = {data: Uint8ClampedArray, width, height, colorSpace: 'srgb'}
  // convert the Uint8ClampedArray to a data URL

  if (!imageData || !imageData.width || !imageData.height || !imageData.data) {
    throw new Error("Invalid imageData object. It should have width, height, and data properties.");
  }

  // Create a canvas element and set its dimensions
  var canvas = document.createElement("canvas");
  canvas.width = imageData.width;
  canvas.height = imageData.height;

  // Get a 2D rendering context
  var context = canvas.getContext("2d");
  if (!context) {
    throw new Error("Unable to create 2D rendering context.");
  }

  // Draw the image data onto the canvas
  context.putImageData(imageData, 0, 0);
  return canvas;
}
function useIRRenderer() {
  var Renderer = (0, _useRenderer.default)();
  var storeImageInfo = (0, _useImageInfo.default)();
  var storeMarkerInfo = (0, _useMarkerInfo.default)();
  var _Renderer$isReady = Renderer.isReady,
    isReady = _Renderer$isReady === void 0 ? false : _Renderer$isReady,
    loadBuffer = Renderer.loadBuffer,
    runRender = Renderer.runRender,
    getJSON = Renderer.getJSON,
    getImageVL = Renderer.getImageVL,
    getImageIR = Renderer.getImageIR,
    getMarkerObject = Renderer.getMarkerObject,
    getPaletteData = Renderer.getPaletteData,
    restRenderFuncs = _objectWithoutProperties(Renderer, _excluded);
  var imageInfo = storeImageInfo.imageInfo,
    setImageInfo = storeImageInfo.setImageInfo,
    modifyImageInfo = storeImageInfo.modifyImageInfo;
  var setMarkerInfo = storeMarkerInfo.setMarkerInfo,
    modifyMarkerInfo = storeMarkerInfo.modifyMarkerInfo,
    getNextMarkerIndex = storeMarkerInfo.getNextMarkerIndex,
    deleteFromMarkerInfo = storeMarkerInfo.deleteFromMarkerInfo,
    restMarkerFuncs = _objectWithoutProperties(storeMarkerInfo, _excluded2);
  var _useColorbar = (0, _useColorbar3.default)(),
    _useColorbar2 = _slicedToArray(_useColorbar, 2),
    paletteGradient = _useColorbar2[0],
    setPaletteData = _useColorbar2[1];
  var _useState = (0, _react.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    images = _useState2[0],
    setImages = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  var loadPreview = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(buffer) {
      var newImagePreview;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            if (!(buffer.byteLength > 0)) {
              _context.next = 6;
              break;
            }
            _context.next = 4;
            return createImageFromBuffer(buffer);
          case 4:
            newImagePreview = _context.sent;
            setImages(function (images) {
              return _objectSpread(_objectSpread({}, images), {}, {
                preview: newImagePreview
              });
            });
          case 6:
            _context.next = 11;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            console.error("Error loading preview:", _context.t0);
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 8]]);
    }));
    return function (_x2) {
      return _ref.apply(this, arguments);
    };
  }(), []);
  var renderImages = (0, _react.useCallback)(
  // typically called once loadImages has been called or once imageInfo has updated
  function (newImageInfo) {
    if (Object.keys(newImageInfo).length > 0) {
      setIsLoading(true);
      runRender(newImageInfo);
      var newImageVL = imageDataToCanvas(getImageVL());
      var newImageIR = imageDataToCanvas(getImageIR());
      setImages(function (images) {
        return _objectSpread(_objectSpread({}, images), {}, {
          vl: newImageVL,
          ir: newImageIR
        });
      });

      // update marker store
      var imageJSON = getJSON() || {};
      if (Object.keys(imageJSON).length > 0) {
        // load local info store
        var MARKERS = imageJSON.OUTPUT_MARKERS;
        setMarkerInfo(MARKERS);
        setImageInfo(_objectSpread(_objectSpread({}, newImageInfo), {}, {
          MARKERS: MARKERS
        }));

        // set the palette gradient
        setPaletteData(getPaletteData());
      }
      setIsLoading(false);
    }
  }, [runRender, getImageVL, getImageIR, getJSON, setMarkerInfo, setImageInfo, setPaletteData, getPaletteData]);
  var loadImages = (0, _react.useCallback)(
  /*#__PURE__*/
  // typically called whenever a new image-id is loaded
  function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(data) {
      var info, preview, visual, irdata;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (Object.keys(data).length > 0) {
              info = data.info.response, preview = data.preview.response, visual = data.visual.response, irdata = data.irdata.response;
              try {
                // load renderer
                loadPreview(preview);
                loadBuffer({
                  info: info,
                  visual: visual,
                  irdata: irdata
                });
                // run renderer
                renderImages(info);
              } catch (error) {
                console.error("Error rendering new images:", error);
              }
            }
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x3) {
      return _ref2.apply(this, arguments);
    };
  }(), [loadPreview, loadBuffer, renderImages]);

  // LOCAL STORE UPDATER
  var updateImageInfo = (0, _react.useCallback)(function () {
    var newImageInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var render = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    // update the current image info consumed by irviewer
    if (Object.keys(newImageInfo).length > 0) {
      // update local stores
      setImageInfo(newImageInfo);
      setMarkerInfo(newImageInfo.MARKERS);

      // render new images
      render && renderImages(newImageInfo);
    }
  }, [renderImages, setImageInfo, setMarkerInfo]);
  var updateMarkerInfo = (0, _react.useCallback)(function () {
    var nextMarkers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // update imageInfo MARKERS
    // always skip render when updating markers (update directly)
    var shouldRender = false;

    // get modified markerInfo then global update to imageInfo
    if (Object.keys(nextMarkers).length > 0) {
      var newImageInfo = _objectSpread(_objectSpread({}, imageInfo), {}, {
        MARKERS: nextMarkers
      });
      updateImageInfo(newImageInfo, shouldRender);
    }
  }, [imageInfo, updateImageInfo]);
  var updateSettings = (0, _react.useCallback)(function () {
    var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var shouldRender = true;
    // gets modified imageInfo then global update to imageInfo
    if (Object.keys(settings).length > 0) {
      var _modifyImageInfo = modifyImageInfo(settings),
        modifiedImageInfo = _modifyImageInfo.modifiedImageInfo,
        changedKeys = _modifyImageInfo.changedKeys;

      // exempt from render
      var exemptFromRender = ["globalMarkerVisible", "irOrientation", "EditorNotes", "referenceMarkerId", "status"];

      // do not render if only one change detected and is an exemption
      if (changedKeys.length === 0 || changedKeys.length === 1 && changedKeys.some(function (item) {
        return exemptFromRender.includes(item);
      })) {
        shouldRender = false;
      }
      // update imageInfo store
      updateImageInfo(modifiedImageInfo, shouldRender);
    }
  }, [modifyImageInfo, updateImageInfo]);
  var updateMarker = (0, _react.useCallback)(function () {
    var _name;
    var nextMarker = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    /**
     * 1. update marker by building marker object,
     * 2. get modified local markers
     * 3. finally global update to imageInfo
     */
    var type = nextMarker.type,
      id = nextMarker.id,
      name = nextMarker.name,
      attrs = _objectWithoutProperties(nextMarker, _excluded3);
    name = (_name = name) !== null && _name !== void 0 ? _name : getNextMarkerIndex(type);

    // add or modify marker object without mutation
    var marker = getMarkerObject(_objectSpread({
      type: type,
      id: id,
      name: name
    }, attrs));
    id = marker.characteristics.uniqueIDString;
    name = marker.characteristics.markerName;

    // update marker store
    var newMarkerInfo = modifyMarkerInfo({
      id: id,
      type: type,
      marker: marker
    });
    updateMarkerInfo(newMarkerInfo);

    // return the new or existing id and name for marker
    return {
      id: id,
      name: name
    };
  }, [getNextMarkerIndex, getMarkerObject, modifyMarkerInfo, updateMarkerInfo]);
  var deleteMarker = (0, _react.useCallback)(function (id) {
    var newMarkerInfo = deleteFromMarkerInfo(id);
    updateMarkerInfo(newMarkerInfo);
  }, [deleteFromMarkerInfo, updateMarkerInfo]);
  var handleMarkerChange = (0, _react.useCallback)(function (attrs) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "update";
    switch (type) {
      case "delete":
        // delete marker by id
        deleteMarker(attrs);
        break;
      case "update":
      default:
        // update or create marker
        return updateMarker(attrs);
    }
  }, [deleteMarker, updateMarker]);
  return _objectSpread(_objectSpread({
    images: images,
    isLoading: isLoading,
    loadImages: loadImages,
    updateSettings: updateSettings,
    paletteGradient: paletteGradient,
    // from info
    imageInfo: imageInfo,
    // from renderer
    isReady: isReady,
    getPaletteData: getPaletteData
  }, restRenderFuncs), {}, {
    // from markers
    updateMarker: handleMarkerChange
  }, restMarkerFuncs);
}